import {useEffect} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import "./style.css";

import UnauthorizedPage from "./UnauthorizedPage";
import { Header } from "./components/Header";
import ScrollToTop from "./common/ScrollToTop";

import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

import AuthCallBack from "./pages/AuthCallBack";
import ClientDetailPage from "./pages/ClientDetails";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import NotFoundPage from "./pages/NotFoundPage";
import TeamDetailPage from "./pages/TeamDetails";
import TeamDetailPageNew from "./pages/TeamDetailsNew";
import TeamListing from "./pages/TeamListingNew";
import TeamsOverview from './pages/TeamsOverview';
import TouchpointTracker from "./pages/TouchpointTracker";
import TouchpointTrackerNew from "./pages/TouchpointTrackerNew";

function App() {

  // useEffect(() => {
  //     localStorage.getItem('activeTab') && localStorage.removeItem('activeTab');
  //     localStorage.getItem('expandedClients') && localStorage.removeItem('expandedClients');
  //     localStorage.getItem('expandedBUs') && localStorage.removeItem('expandedBUs');
  // },[])

  return (
    <>
    <Toaster position="top-right" />
      <AuthProvider>
          <Router>
            <Header />
            <div style={{ marginBottom: "3em" }}></div>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/callback" element={<AuthCallBack />} />
              <Route path="/error" element={<UnauthorizedPage />} />
              <Route path="/customers" element={<ProtectedRoute><ClientDetailPage /></ProtectedRoute>}/>
              <Route path="/customers/:customerKey" element={<ProtectedRoute><TeamListing /></ProtectedRoute>}/>
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}/>
              <Route path="/teams" element={<ProtectedRoute><TeamsOverview /></ProtectedRoute>}/>
              <Route path="/team/:customerKey/:teamKey" element={<ProtectedRoute><TeamDetailPageNew /></ProtectedRoute>}/>
              <Route path="/touchpoints" element={<ProtectedRoute><TouchpointTrackerNew /></ProtectedRoute>}/>
              <Route path="*" element={<ProtectedRoute><NotFoundPage /></ProtectedRoute>}/>
            </Routes>
          </Router>
      </AuthProvider>
    </>
  );
}

export default App;
